// guards/admin.guard.ts

import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { AutenticarService } from "../servicios/autenticar.service";

@Injectable({
  providedIn: "root",
})
export class AdminGuardService implements CanActivate {
  constructor(
    private autenticaService: AutenticarService,
    private router: Router
  ) {}

  canActivate(): boolean {
    //console.log("AdminGuard: Verificando acceso de administrador...");
    if (this.autenticaService.isAdmin()) {
      return true;
    } else {
      this.router.navigate(["/portada"]);
      return false;
    }
  }
}
